import '../util/overrides'
import Model from './Model'
import Axios from 'axios'
import qs from 'qs'

class Collection extends Array {
    static useAuthToken = false;
    authToken = null;
    url = String;
    dataSource = null;
    defaultUrl = '/api'
    autoLoad = false;
    rootProperty = 'data';
    checkSuccess = true;
    successProperty = 'meta.return_code'
    totalCountProperty = 'total'
    model = Model;
    loaded = false;
    loading = false;
    params = {};
    lastRequestParams = {};
    trackRemoved = true;
    removed = [];
    keepData = true;
    removeFromSession = true;
    initialCount = 0;
    count = 0;
    totalCount = 0;
    sorterFn = null;
    requestSource = null;
    method = 'POST';
    append = false;

    events = {
        'recordcreated': function(){}
    }

    constructor(config = {}){
        config = config || {};
        super();
        this.dataSource = config.dataSource || this.dataSource;
        this.url = this.getUrl(config);
        this.method = config.method || this.method;
        this.model = config.model || this.model;
        this.params = config.params || this.params;
        this.autoLoad = config.autoLoad == true ? config.autoLoad : this.autoLoad;
        this.append = config.append == true ? config.append : this.append;
        this.rootProperty = typeof config.rootProperty != 'undefined' ? config.rootProperty : this.rootProperty;
        this.totalCountProperty = typeof config.totalCountProperty != 'undefined' ? config.totalCountProperty : this.totalCountProperty;
        this.checkSuccess = config.checkSuccess === false ? false : this.checkSuccess;
        this.successProperty = config.successProperty || this.successProperty;
        this.removeFromSession = config.removeFromSession == false ? config.removeFromSession : this.removeFromSession;
        this.keepData = config.keepData == false ? config.keepData : this.keepData;
        this.sorterFn = config.sorterFn || null;

        if(config.events){
            for(var p in config.events){
                if(this.events[p]){
                    this.events[p] = config.events[p];
                }
            }
        }

        if(!this.url){
            throw new Exception('Please define url for collection of ' + this.model);
        }
        if(this.autoLoad){
            this.load();
        }
    }

    getUrl = function(config){
        var url = config.url || this.url;

        if(config.dataSource){
            url = this.defaultUrl;
        }

        return url;
    }

    getDataSourceParams = function(params) {
        return {
            dataSource: this.dataSource
            , params: JSON.stringify(Object.deepCopyPruned(params))
        }
    }

    hasSession = function(){
        return !!this.model.session;
    }

    getSession = function(){
        return this.model.session;
    }

    add = function(rec, insertIndex){
        var index = this.indexOfExact(rec);
        /*
            Adding new record to the collection
            if record exist change the existing record with the new one.
        */
        if(index == -1){
            if(this.hasSession()){
                var session = this.getSession();
                if(!(rec instanceof this.model)){
                    rec = new this.model(rec);
                }
                if(!rec.phantom && !session.getters.isRecordExist(this.model.name, rec[this.model.idProperty])){
                    session.commit('regRecord', rec);
                }
            }
            else if(!(rec instanceof this.model)){
                rec = new this.model(rec);
            }

            if (Object.isEmpty(insertIndex)) {
                this.push(rec);
            } else {
                this.splice(insertIndex, 0, rec)
            }
        }
        else{
            this.splice(index, 1, rec);
        }

        rec._collection = this;

        this.applySort();

        return rec;
    }

    abortLoad = function(){
        if(this.requestSource){
            this.requestSource.cancel();
            this.loading = false;
        }
    }
    load = function(force = false, config = {}){
        if(!this.loaded || force === true){
            var loadParams = config.params || {},
                params = Object.assign(this.params, loadParams),
                append = config.append === true ? config.append : this.append

            if (this.dataSource) {
                params = this.getDataSourceParams(params);
            }

            let request = Axios.create(),
                headers = { 'content-type': 'application/x-www-form-urlencoded' },
                cancelToken = Axios.CancelToken,
                source = cancelToken.source()

            if(Collection.useAuthToken){
                headers['Authorization'] = `Bearer ${Collection.getAuthToken()}`;
            }

            this.requestSource = source

            request.interceptors.request.use(
                cfg => {
                    this.loaded = false;
                    this.loading = true;
                    this.splice(1, 0);
                    if (typeof config.beforesend == 'function') {
                        config.beforesend.call(this);
                    }
                    return cfg;
                }, error => {
                    this.loaded = false;
                    this.loading = false;
                    this.splice(1, 0);
                }
            )

            this.lastRequestParams = params

            this.loadProcess = request.request({
                url: (Collection.getUrl ? Collection.getUrl(this.url) : this.url) + this.getCacheParam()
                , cancelToken: source.token
                , headers: headers
                , method: this.method
                , params: this.method.toLowerCase() == 'get' ? params : null
                , data: this.method.toLowerCase() == 'get' ? null : qs.stringify(params)
            }).then((response) => {
                response = response ? response.data : {};
                var list = []
                    , returnCode = this.checkSuccess ? Object.getDescendant(response, this.successProperty) : 0
                    , totalCount = Object.getDescendant(response, this.totalCountProperty);

                if (this.length > 0 && !append) {
                    this.removeAll();
                }

                if (response.meta && response.meta.auth_token) {
                    Model.setAuthToken(response.meta.auth_token);
                    Collection.setAuthToken(response.meta.auth_token);
                }

                if(returnCode == 0){
                    list = [].concat(Object.getDescendant(response, this.rootProperty) || []);
                    this.loadData(list);
                    this.totalCount = totalCount || this.length
                    this.loading = false;
                    this.loaded = true;
                    if (typeof config.success == 'function') {
                        config.success.call(this, response)
                    }
                } else {
                    this.loading = false;
                    this.loaded = false;

                    if (returnCode == 99 || returnCode == 89 || returnCode == 79 || returnCode == 69) {
                        Model.removeAuthToken()
                        var redirectPath = '/'
                        if (response.data && response.data.redirect) {
                            redirectPath = response.data.redirect
                        }

                        window.top.location = redirectPath;
                    }
                    else if (typeof config.failure == 'function') {
                        config.failure.call(this, response, returnCode)
                    }
                }

                if (typeof config.complete == 'function') {
                    config.complete.call(this, response);
                }

                this.splice(1, 0);

            }).catch((error) => {
                this.loading = false;
                this.loaded = false;
                this.splice(1, 0);

                if (typeof config.failure == 'function') {
                    config.failure.call(this, error)
                }

                if (typeof config.complete == 'function') {
                    config.complete.call(this, error);
                }
            })
        }
    }
    loadData = function(list){
        if(list instanceof Array){
            for(var i = 0;i<list.length;i++){
                var rec = null, item = list[i];
                if(this.hasSession()){
                    rec = this.getSession().getters.getRecord(this.model.name, item[this.model.idProperty]);
                    if(rec){
                        rec.setData(item);
                    }
                }
                if(!rec){
                    rec = new this.model(item);
                }

                rec._collection = this;

                if(this.keepData != false){
                    this.push(rec);
                }
                this.events['recordcreated'](this, rec);
            }
            this.applySort();
            this.commit();
        }
    }

    removeAll = function(){
        while(this.length > 0){
            this.remove(this[0]);
        }
    }
    remove = function(item){
        var index = this.indexOf(item);
        if(index > -1){
            if(this.trackRemoved && !item.phantom){ // BR for phantom???
                if(this.removed.indexOf(item) == -1){
                    this.removed.push(item);
                }
            }
            this.splice(index, 1);
            if(this.hasSession() && this.removeFromSession == true){
                this.getSession().commit('evict', item);
            }
        }
    }
    getById = function(id){
        var item = null;
        for(var i = 0;i<this.length;i++){
            if(this[i][this.model.idProperty] == id){
                item = this[i];
                break;
            }
        }
        return item;
    }
    indexOfExact = function(item){
        var idProp = this.model.idProperty, index = -1, id;
        if(idProp && !Object.isEmpty((id = item[idProp]))){
            index = this.indexOf(this.getById(id));
        }
        else{
            index = this.indexOf(item);
        }
        return index;
    }
    reject = function(){
        var i = 0;
        while(this.length > 0 && i < this.length){
            if(this[i].phantom){ // BR for phantom
                this.remove(this[i]);
            }
            else{
                this[i].reject();
                i++;
            }
        }
        if(this.trackRemoved && this.removed.length > 0){
            var removed, i = 0, len = this.removed.length;
            for(;i<len;i++){
                removed = this.removed[i];
                this.add(removed);
            }
        }
        this.count = this.length;
    }
    commit = function(commitRecords){
        this.count = this.length;
        if(commitRecords != false){
            for(var i = 0;i<this.length;i++){
                this[i].commit();
            }
        }
        if(this.trackRemoved && this.removed.length > 0){
            while(this.removed.length > 0){
                this.removed.splice(0, 1);
            }
        }
    }

    isModified = function(){
        var modified = this.count != this.length;
        if(!modified){
            for(var i = 0;i<this.length;i++){
                modified = this[i].isModified();
                if(modified){
                    break;
                }
            }
        }
        if(!modified){
            this.count = this.length;
        }
        return modified;
    }

    getData = function(associated){
        var data = [];
        for(var i = 0;i<this.length;i++){
            var recordData = this[i].getData(associated);
            if(recordData){
                data.push(recordData);
            }
        }
        return data;
    }

    getCacheParam = function(){
        return '?dc=' + (Math.random() * 1000000);
    }

    serialize = function (operand) {
        operand = operand || ','
        var data = []
        this.forEach(item => { data.push(item[item.constructor.idProperty]) })
        return data.join(',')
    }

    applySort = function () {
        if(this.sorterFn){
            this.sort(this.sorterFn);
        }
    }
}
export default Collection;
